export enum StepState {
  COMPLETED = 'COMPLETED',
  DISABLED = 'DISABLED',
  ERROR = 'ERROR',
  ACTIVE = 'ACTIVE',
}
